import { render, staticRenderFns } from "./ContactNote.vue?vue&type=template&id=08e17f47&"
import script from "./ContactNote.vue?vue&type=script&lang=js&"
export * from "./ContactNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports